import React from "react";

export default function EvaluationQuestionChoice({ question, value, onChange, disabled }) {
    const options = [...(question.options || [])].sort((a, b) => (a.position || 0) - (b.position || 0));

    return (
        <div className="qr-options-list qr-options-list--compact">
            {options.map((option) => (
                <label
                    key={option.id || option.value}
                    className={`qr-option-card ${String(value) === String(option.id) ? "is-selected" : ""}`}
                >
                    <input
                        type="radio"
                        name={`evaluation-question-${question.id}`}
                        value={option.id}
                        checked={String(value) === String(option.id)}
                        onChange={() => onChange(option.id)}
                        disabled={disabled}
                    />
                    <span>{option.label || option.value}</span>
                </label>
            ))}
        </div>
    );
}
